const moment = require('moment');

/**
 * Filters and clips a flat events array for a single calendar month.
 *
 * Rules:
 *  - Attractions (and any non-accommodation type): appear only on the month
 *    whose range contains the event's start date.
 *  - Accommodations: appear on every month they overlap, clipped to that
 *    month's boundaries so they never duplicate across calendars.
 */
function filterEventsForMonth(events, monthDate) {
  const monthStart = moment(monthDate).startOf('month');
  const monthEnd = moment(monthDate).endOf('month');

  return events.reduce((result, event) => {
    if (event.extendedProps?.type === 'accommodation') {
      const eventStart = moment(event.start);
      const eventEnd = moment(event.end);

      if (eventStart.isSameOrBefore(monthEnd, 'day') && eventEnd.isAfter(monthStart, 'day')) {
        const clippedStart = eventStart.isBefore(monthStart)
          ? monthStart.format('YYYY-MM-DD')
          : event.start;
        const dayAfterMonthEnd = monthEnd.clone().add(1, 'day').format('YYYY-MM-DD');
        const clippedEnd = eventEnd.isAfter(monthEnd) ? dayAfterMonthEnd : event.end;
        result.push({ ...event, start: clippedStart, end: clippedEnd });
      }
    } else {
      if (moment(event.start).isBetween(monthStart, monthEnd, 'day', '[]')) {
        result.push(event);
      }
    }
    return result;
  }, []);
}

module.exports = { filterEventsForMonth };
